import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../../libraries/utils/components/icon.tsx';
import classnames from 'classnames';

class CheckboxInput extends Component {
  handleChange = () => {
    if (!this.props.disabled) {
      let checkboxInput = this.refs.checkboxInput;
      let value = !checkboxInput.checked;
      this.props.onChange(value);
    }
  };

  render() {
    let checked = this.props.value;
    let {
      comment,
      title,
      description,
      text,
      className,
      disabled,
      onlyCheckBoxClick,
      gapTopSize
    } = this.props;
    let commentComponent = null;
    let descriptionComponent = null;
    className = 'field' + (className ? ' ' + className : '');
    if (comment) {
      commentComponent = <div className="comment">{comment}</div>;
    }

    if (description) {
      descriptionComponent = <div className="field-description">{description}</div>;
    }

    let checkedIcon = <Icon className="checked-icon" name="check" />;

    let cbClassName = classnames('label-box', {
      checked: checked,
      disabled: disabled
    });

    let textClassName = classnames('text', {
      disabled: disabled
    });

    return (
      <div
        className={classnames('field', className, {
          ['--gap-top-size-' + gapTopSize]: gapTopSize || null
        })}
      >
        {title && <div className="field-title">{title}</div>}
        {descriptionComponent}
        <div className={cbClassName} onClick={!onlyCheckBoxClick ? this.handleChange : undefined}>
          <span className="checkbox" onClick={this.handleChange}>
            <input
              disabled={disabled}
              checked={!!checked}
              ref="checkboxInput"
              readOnly
              type="checkbox"
            />
            {checked && checkedIcon}
          </span>
          <label className={textClassName}>{text}</label>
        </div>
        {commentComponent}
      </div>
    );
  }
}

CheckboxInput.propTypes = {
  value: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  description: PropTypes.string,
  onChange: PropTypes.func,
  comment: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onlyCheckBoxClick: PropTypes.bool,
  onClick: PropTypes.func
};

CheckboxInput.contextTypes = {
  executeAction: PropTypes.func.isRequired
};

CheckboxInput.defaultProps = {
  disabled: false,
  onlyCheckBoxClick: false,
  onClick: () => {},
  onChange: () => {}
};

CheckboxInput.displayName = 'CheckboxInput';

export default CheckboxInput;
